module.exports = __webpack_public_path__ + "img/5141097 1(1).1fe77da3.png";